import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { TransparentButton, ButtonType } from '@checkmarx/cx-ui'

export default class SsoLoginForm extends Component {

    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.loginSettings.macAutoRedirect) {
            var autoRedirect = window.localStorage.getItem('AutoRedirect');

            if (this.buttonRef.current && (autoRedirect === "true" || autoRedirect === null)) {
                const buttonElement = ReactDOM.findDOMNode(this.buttonRef.current);
                const clickEvent = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });
                buttonElement.dispatchEvent(clickEvent);
            }
        }
    }

    render() {

        let externalLoginUrl = `./identity/externalLogin`;

        return (
            <form action={externalLoginUrl} method='post'>
                <div>
                    <input type='hidden' name='redirectUrl' value={this.props.returnUrl} />
                    <div style={{ marginBottom: '15px' }}>
                        <TransparentButton
                            ref={this.buttonRef}
                            buttonType={ButtonType.blue}
                            dataCy='btn-external-login'
                            name='providerid'
                            value={this.props.provider.id}
                            text={this.props.provider.name}
                            style={{
                                color: '#4a90e2',
                                borderColor: '#4a90e2',
                                height: '40px',
                                width: '325px',
                                textTransform: 'initial',
                                fontSize: '15px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                        </TransparentButton>
                    </div>
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/account/ssoLoginForm.jsx